<template>
  <div >
    <div class="show-content-box" v-html="myContent" v-if="disabled"/>
    <vue-ueditor-wrap v-else v-model="myContent" editor-id="editorId" :config="myConfig" :editor-dependencies="['ueditor.config.js','ueditor.all.js']"></vue-ueditor-wrap>
  </div>
</template>
<script>
  import VueUeditorWrap from 'vue-ueditor-wrap'
  import store from '@/store'
  import Constant from '@/constant/index'

  export default {
    components: {
      VueUeditorWrap
    },
    props: [
      "value",
      "editStyle", //样式
      "editorId",
      "disabled",
    ],
    data () {
      return {
        myContent:'',
        myConfig: {
          UEDITOR_HOME_URL: process.env.NODE_ENV === 'development' ? "/UEditor/" : '/talent-project-apply/UEditor/',
          initialFrameHeight: 550, // 高度
          autoHeightEnabled: false, // 禁止自动增高，改用滚动条
          elementPathEnabled: false, // 是否启用元素路径，默认是true显示
          serverUrl: Constant.API_HOST + '/remote/talentEntrepreneurship/common/ueditor/config',
        },
      }
    },
    watch: {
      value(val) {
        this.myContent = val;
      },
      myContent(val) {
        if(val != undefined) {
          this.$emit('input',val);
        }
      },

    },
    computed:{
    },
    created () {
      this.myContent = this.value ? this.value : ''
    },
    methods: {
    }
  }
</script>
<style>
  .show-content-box{
    height: 550px;
    overflow: auto;
    border: 1px dashed #ccc;
    padding: 10px;
    line-height: 20px;
  }
</style>
